import React from 'react';
import withRedux from 'next-redux-wrapper';
import {initStore} from 'src/store';
import {DefaultLayout} from 'src/layouts';
import ErrorPage from 'src/components/error';
import WithSession from 'src/components/hoc/withSession';

class Error extends React.Component {
  static getInitialProps({ res, jsonPageRes }) {
    // if we need to do anything with status code later??
    const statusCode = res ? res.statusCode : (jsonPageRes ? jsonPageRes.status : null);
    return { statusCode };
  }

  render() {
    return (
      <DefaultLayout>
        <ErrorPage />
      </DefaultLayout>
    );
  }
}

export default withRedux(initStore, null, null)(WithSession(Error));



// WEBPACK FOOTER //
// ./pages/_error.js